/**
 * @module ServiceTestsColumns
 * @description Assembles static and dynamic Service Test list columns.
 */

import {
    getTypeIconColumn,
    getNameColumn,
    getStatusColumn,
    getScheduleTypeColumn,
    getInterfaceColumn,
    shouldShowInterfaceColumn,
    getScheduleIntervalColumn,
    getScheduleTimeColumn,
    getBusinessServicesColumn,
    getTagsColumn,
} from './ServiceTestsStaticColumns';
import { buildDynamicColumns } from './ServiceTestsDynamicColumns';

/**
 * Build the complete column configuration for ServiceTestsListPanel.
 *
 * @param {Array} testTypeArrayObject - Array of test type config objects
 * @param {string} group - Test group identifier
 * @returns {Array} Column configuration array for DataTable
 */
export function getColumns(testTypeArrayObject, group) {
    const columns = [
        getTypeIconColumn(),
        getNameColumn(group),
        getStatusColumn(),
        getScheduleTypeColumn(),
        getScheduleIntervalColumn(),
        getScheduleTimeColumn(),
        getBusinessServicesColumn(),
    ];

    if (shouldShowInterfaceColumn(testTypeArrayObject)) {
        columns.push(getInterfaceColumn());
    }

    columns.push(...buildDynamicColumns(testTypeArrayObject));

    columns.push(getTagsColumn());

    return columns;
}
